import { AnyAction, isType } from 'typescript-fsa';
import { UseCaseAccounting } from '../../../services/account';
import { sysadminSetUseCaseLogs } from './actions';

export interface UseCaseLogState {
    [server: string]: UseCaseAccounting[];
}

const initialUseCaseLogState: UseCaseLogState = {};

export function useCaseLogReducer(state: UseCaseLogState = initialUseCaseLogState, action: AnyAction): UseCaseLogState {
    if (isType(action, sysadminSetUseCaseLogs)) {
        return { ...state, [action.payload.server]: action.payload.useCaseLogs };
    }
    return state;
}
